/* eslint-disable complexity */
import { ShapeMutationAPI } from '../api/shape-mutation-api';
import { ShapeProps } from '../props/shape/shape-props';
import { ShapeStore } from '../store/shape-store';
import { BaseShapeDataModel } from './base-shape-data-model';
import type { PageContext } from '../context/page-context';
import type { IEventManager } from '../manager/event-manager';
import type { IShapeData } from '../data';
import type { IShapeProps } from '../props/shape/shape-props';
import type { RestrictedDataModel } from './data-model';
import type { GroupShapeDataModel } from './group-shape-data-model';
import type { SmartArtDataModel } from './smart-art-data-model';

export class ShapeDataModel extends BaseShapeDataModel<IShapeData> {
    public store: ShapeStore;
    public props: IShapeProps;
    public api: ShapeMutationAPI;

    public constructor(
        data: IShapeData,
        events: IEventManager,
        context: PageContext,
        public parent: GroupShapeDataModel | SmartArtDataModel,
    ) {
        super(events, context);

        this.store = new ShapeStore(data, events, this);
        this.props = new ShapeProps(this.store.data, this.context);
        this.api = new ShapeMutationAPI(this, events);
    }

    /**
     * 获取此 shape 在母版版式上相关联的 shapeModel（占位符）
     */
    public getRelatedPlaceholder() {
        return this.context.getPlaceholder(this.props.nvPr?.ph);
    }

    public getText(): string {
        const textBody = this.props.txBody;
        if (!textBody) {
            return '';
        }

        let text = '';
        for (const paragraph of textBody.p ?? []) {
            for (const run of paragraph.egTextRun ?? []) {
                if (run.r) {
                    text += run.r.t ?? '';
                }

                if (run.br) {
                    text += '\n';
                }

                if (run.fld) {
                    text += run.fld.t ?? '';
                }
            }
            text += '\n';
        }

        return text.slice(0, -1);
    }
}

export { IShapeProps };
export type IShapeDataModel = RestrictedDataModel<ShapeDataModel>;
